export default "__VITE_ASSET__Bfa$Z$lE__"